export enum ClientStorageKeys {
  PreferProgrammingLanguage = 'PreferProgrammingLanguage',
  UserHasCompletedFirstProblem = 'UserHasCompletedFirstProblem',
  AchievementsWelcomeSeen = 'AchievementsWelcomeSeen',
}
